<template>
    <nav v-if="pagination.last_page > 1" aria-label="stronicowanie">
        <ul class="pagination justify-content-center">
            <li v-if="page > 1" class="page-item">
                <a class="page-link" href="#" v-on:click="setPage(page - 1)" aria-label="Poprzednia">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>
            <li v-for="n in pagination.last_page" :class="'page-item' + (n == page ?  ' active ' : '')" aria-current="page" :key="n">
                <a class="page-link" href="#" v-on:click="setPage(n)" v-html="n"></a>
            </li>
            <li v-if="page < pagination.last_page" class="page-item">
                <a class="page-link" href="#" v-on:click="setPage(page + 1)" aria-label="Następna">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        props: ['page', 'perPage', 'pagination', 'method'],

        methods: {
            setPage(page){
                this.method(page);
            }
        }

    }
</script>
